export default __webpack_public_path__ + "static/media/arrowLeftHeader.3abf9a36.svg";